var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCircledotted3X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12357 24.8184C2.49674 26.3164 1.95489 27.8569 1.51929 29.4081L51.5812 79.47C53.1323 79.0344 54.6623 78.4925 56.1709 77.8657L3.12357 24.8184Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56597 18.3376C5.72665 19.6126 4.98294 20.93 4.30298 22.2687L58.7209 76.6865C60.0596 76.0066 61.377 75.2629 62.6519 74.4236L6.56597 18.3376Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9327 12.8022C9.92335 13.8859 8.97777 15.0015 8.09595 16.1595L64.83 72.8935C65.988 72.0223 67.1142 71.0768 68.1872 70.0568L10.9327 12.8022Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8538 27.4109C76.9202 21.7269 73.6904 16.3722 69.1538 11.8463C64.6172 7.30966 59.2731 4.07987 53.5891 2.14624L78.8538 27.4109Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 80.2244C34.7947 80.6812 37.1321 80.9362 39.4694 81L0 41.5305C0.0637461 43.8679 0.308118 46.1946 0.775589 48.5001L32.4999 80.2244Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.79691 32.4043C0.425058 34.2104 0.191331 36.0378 0.0744629 37.8758L43.1243 80.9257C44.9623 80.8088 46.7897 80.5645 48.5958 80.2032L0.79691 32.4043Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2686 4.30273C20.93 4.98269 19.6126 5.72639 18.3376 6.56571L74.4342 62.6622C75.2735 61.3873 76.0172 60.0699 76.6972 58.7312L22.2686 4.30273Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4896 0.775573C46.1947 0.318726 43.8574 0.0637461 41.52 0L80.9894 39.4694C80.9257 37.1321 80.6813 34.8053 80.2139 32.4999L48.4896 0.775573Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1355 53.5786C4.06913 59.2626 7.29893 64.6173 11.8355 69.1433C16.3721 73.6799 21.7162 76.9097 27.4002 78.8433L2.1355 53.5786Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4083 1.51929C27.8571 1.95489 26.3273 2.49674 24.8186 3.12357L77.8659 56.1709C78.4927 54.6729 79.0346 53.1324 79.4702 51.5812L29.4083 1.51929Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8651 0.0744629C36.0271 0.191331 34.1997 0.435699 32.3936 0.796927L80.1925 48.5959C80.5643 46.7897 80.798 44.9623 80.9149 43.1243L37.8651 0.0744629Z",
    fill: "#BC85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1598 8.10645C15.0017 8.97764 13.8755 9.92321 12.8025 10.9431L70.0677 68.2083C71.077 67.1247 72.0226 66.0091 72.9044 64.851L16.1598 8.10645Z",
    fill: "#BC85FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCircledotted3X);
export default __webpack_public_path__ + "static/media/img_circle dotted@3x.41dae6b4f0abf7bfa3ab2acbc8e1a861.svg";
export { ForwardRef as ReactComponent };